<template>
    <div class="flex flex-column gap-4 w-full" v-if="!enrolledStudent">
        <div class="w-full surface-50 border-round p-4">
            <div class="flex flex-column align-items-center w-full">
                <p class="text-center Paragraph-Regular w-full mt-2">Available for enrolled students only!</p>
            </div>
        </div>
    </div>

    <div class="flex flex-column gap-4 w-full" v-else>
        <div v-if="notices && notices.length === 0" class="w-full surface-50 border-round p-4">
            <div class="flex flex-column align-items-center w-full">
                <p class="text-center Paragraph-Regular w-full mt-2">No notices available at this time.</p>
            </div>
        </div>
        <div v-for="notice in notices" :key="notice._id" class="w-full surface-50 border-round p-4">
            <div class="flex flex-column align-items-center w-full">
                <h3 class="text-center H6-Medium w-full">{{ notice.title }}</h3>
                <div class="text-center Paragraph-Regular w-full mt-2 notice-description" v-html="notice.description"></div>
                <div class="text-sm text-500 mt-2">Posted: {{ new Date(notice.created_at).toLocaleDateString() }}</div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, onMounted, ref } from 'vue';
import { useAuthStore } from "@/stores/authStore";
import * as api from '@/api/student';

const authStore = useAuthStore();
const enrolledStudent = ref(false);

const props = defineProps({
    notices: {
        type: Array,
        default: () => []
    }
});

onMounted(async () => {
    if (!authStore.user) return;
        
    const res = await api.publicEnrolledTutors(authStore.user.userId);
    const list = res.data?.data ?? [];
    for (let i = 0; i < list.length; i++) {
        if (list[i].tutorId === props.notices[0]?.tutorId) {
            enrolledStudent.value = true;
            break;
        }
    }

    if (authStore.user.role == 'institute') {
        enrolledStudent.value = true;
        return;
    }
});
</script>

<style scoped>
.notice-description {
  white-space: normal;     
  word-break: break-word;   
  overflow-wrap: anywhere;  
}

/* Ensure HTML content inherits text alignment */
:deep(.text-center) {
    text-align: center;
}

/* Preserve spacing in HTML content */
:deep(h1),
:deep(h2),
:deep(h3),
:deep(h4),
:deep(h5),
:deep(h6) {
    margin: 0.5em 0;
}

:deep(p) {
    margin: 0.5em 0;
}
</style>